var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":_vm.getCachedRoutePath}},[(_vm.showRouteView)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }